import React, { createContext, useContext, useMemo } from 'react'
import { useFeatureFlag } from '@fs/zion-flags'
import useAccountLinks from '../../../hooks/useLinks/useAccountLinks'
import useLinks from '../../../hooks/useLinks'
import useDynamicNavigation from './useDynamicNavigation'

const NavigationContext = createContext()

export const useNavigationContext = () => {
  const context = useContext(NavigationContext)
  if (!context) {
    throw new Error('useNavigationContext must be used within a NavigationProvider')
  }
  return context
}

function NavigationOldProvider({ children, canSeeTemple, nonReligiousMode, restrictedTemple }) {
  const headerNavigation = useLinks({ canSeeTemple, nonReligiousMode, restrictedTemple })
  const accountNavigation = useAccountLinks()

  const value = useMemo(
    () => ({
      dynamicLinksOn: false,
      headerNavigation,
      accountNavigation,
      isLoading: false,
      isError: false,
    }),
    [headerNavigation, accountNavigation]
  )

  return <NavigationContext.Provider value={value}>{children}</NavigationContext.Provider>
}
function NavigationDynamicProvider({ children }) {
  const { headerNavigation, accountNavigation, isLoading, isError } = useDynamicNavigation(true)

  const dynamicNavigationReady = headerNavigation && !isLoading

  const value = useMemo(
    () => ({
      dynamicLinksOn: true,
      headerNavigation,
      accountNavigation,
      isLoading: !dynamicNavigationReady,
      isError,
    }),
    [headerNavigation, accountNavigation, dynamicNavigationReady, isError]
  )

  return <NavigationContext.Provider value={value}>{children}</NavigationContext.Provider>
}
export default function NavigationProvider({ children, canSeeTemple, nonReligiousMode, restrictedTemple }) {
  const { isOn: dynamicLinksOn } = useFeatureFlag('home_header_dynamicLinks')

  if (dynamicLinksOn) {
    return <NavigationDynamicProvider>{children}</NavigationDynamicProvider>
  }
  return (
    <NavigationOldProvider
      canSeeTemple={canSeeTemple}
      nonReligiousMode={nonReligiousMode}
      restrictedTemple={restrictedTemple}
    >
      {children}
    </NavigationOldProvider>
  )
}
